import React from 'react';
import { List, TextInput, BooleanInput, Filter } from 'react-admin';

import { NameAutocompleteInput } from '../customInputs';
import DeviceDataGrid from './DeviceDataGrid';

const DeviceFilter = (props) => (
	<Filter {...props}>
		<TextInput source="name" alwaysOn />
		<TextInput source="id" alwaysOn />
		<NameAutocompleteInput source="deviceModelId" reference="deviceModel" alwaysOn />
		<NameAutocompleteInput source="shopId" reference="shop" alwaysOn />
		<BooleanInput source="active" alwaysOn />
	</Filter>
);

const DeviceList = (props) => (
	<List
		filters={<DeviceFilter />}
		filterDefaultValues={{ active: true }}
		sort={{ field: 'createdAt', order: 'DESC' }}
		bulkActionButtons={false}
		{...props}
	>
		<DeviceDataGrid />
	</List>
);

export default DeviceList;
